import { ICD9Procedure, ICD9ProcedureQuery } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { TextPattern } from '@dreryk/watermelon';

export const createIcd9ProcedureSearchCreator = (dictionaryValidOn: Date) => {
   return (searchText: string | null) => async () =>
      performCqrsQuerySearch<ICD9Procedure>(() => {
         const query = new ICD9ProcedureQuery();
         query.codeOrName = TextPattern.anywhereIgnoreCase(searchText ?? undefined);
         query.dictionaryValidOn = dictionaryValidOn;
         return query;
      });
};
